import {
  FETCH_ALL_FAQS,
  FETCH_FAQ,
  CREATE_FAQ,
  UPDATE_FAQ,
  DELETE_FAQ,
} from "../types";

const initialState = {
  loading: false,
  message: null,
  data: [],
};

export const faqsReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_ALL_FAQS}_PENDING`:
      return { ...state, message: null, loading: true, data: [] };

    case `${FETCH_ALL_FAQS}_FULFILLED`:
      const result = action.payload.data ? action.payload.data.results : [];
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_ALL_FAQS}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_FAQ}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${FETCH_FAQ}_FULFILLED`:
      const result = action.payload.data?.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data?.message || "",
      };

    case `${FETCH_FAQ}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const createFaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${CREATE_FAQ}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${CREATE_FAQ}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
      };

    case `${CREATE_FAQ}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const updateFaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${UPDATE_FAQ}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${UPDATE_FAQ}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload.results ? action.payload.results : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${UPDATE_FAQ}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};

export const deleteFaqReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${DELETE_FAQ}_PENDING`:
      return { ...state, message: null, loading: true };

    case `${DELETE_FAQ}_FULFILLED`:
      return {
        ...state,
        loading: false,
        data: action.payload ? action.payload : {},
        message: action.payload.message,
        error: action.payload.error,
      };

    case `${DELETE_FAQ}_REJECTED`:
      return {
        ...state,
        loading: false,
        data: null,
        message: `${action.payload.data}`,
      };

    default:
      return state;
  }
};
